import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';
import * as getters from './getters';

const initialState = {
  list: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  detail: { data: null, loading: false },
  allDefs: { data: [], loading: false },
  defAttrs: { data: [], loading: false },
  assetLogsByCode: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  assetLogsByDef: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  conditionTypes: { data: null, loading: false },
  fileTypes: { data: [], loading: false },
  existed: { data: null, loading: false },
  uploadPolicy: { data: null, loading: false },
  dialog: { type: '', visible: false, loading: false },
  confirm: { title: '', content: '', name: '', visible: false, loading: false },
  searchCount: null,
  searchParams: null,
  validError: false,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations, getters } as IStore<IModuleState>;
